import './Switch.css';
import React from 'react';
import { splitter } from '../../RecommendationListing';
const Switch = _ref => {
  let {
    tagsToDisplay,
    rtl,
    selectTag
  } = _ref;
  const type = 'radio';
  const checkboxes = React.useRef();
  const setChecked = (key, index) => {
    let isChecked = false;
    if (index === 0) {
      isChecked = true;
    }
    return isChecked;
  };
  const submitFilters = e => {
    const checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
    let selectedCheckboxes = [];
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selectedCheckboxes.push(checkboxesArray[i].value);
        selectTag(checkboxesArray[i].value);
      }
    }
    selectedCheckboxes = selectedCheckboxes.join(splitter);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select switch"
  }, /*#__PURE__*/React.createElement("div", {
    ref: checkboxes,
    className: `g-checkbox g-checkbox--mob-scroll ${type === 'radio' ? 'g-checkbox-notick' : ''}`
  }, tagsToDisplay.length ? tagsToDisplay.map((key, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: key + index,
      className: "g-checkbox__item"
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      value: key,
      defaultChecked: setChecked(key, index),
      type: type,
      className: `fp__checkbox`,
      id: `gct1-${key + index}`,
      name: "gct1",
      title: key,
      onChange: event => {
        submitFilters(event);
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.checked = !event.target.checked;
          submitFilters(event);
        }
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "body-small g-checkbox__label",
      htmlFor: `gct1-${key + index}`
    }, key));
  }) : null)));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyle : ltrStyle}`
  }, children);
};
export default Switch;
export const commonStyles = "cbw2t9";
const ltrStyle = "l1l26uw";
const rtlStyle = "r10m5qar";